module.exports = __webpack_public_path__ + "img/54.4383ddcd.jpg";